import { render, staticRenderFns } from "./WorkflowStyleLibraryModal.vue?vue&type=template&id=96ce6632&scoped=true"
import script from "./WorkflowStyleLibraryModal.vue?vue&type=script&lang=js"
export * from "./WorkflowStyleLibraryModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowStyleLibraryModal.vue?vue&type=style&index=0&id=96ce6632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce6632",
  null
  
)

export default component.exports